import {InjectionToken} from '@angular/core'
import {LoggingEmbeddedService} from '@service/logging-embedded.service'
import {LoggingService} from '@service/logging.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `LoggingService`.
 *
 * @description
 * En modo embebido devuelve `LoggingEmbeddedService`, que reenvía los
 * logs a la app host. En modo standalone devuelve `LoggingService`,
 * que centraliza el envío a telemetría y reemplaza los usos de
 * `console.log/warn/error` prohibidos por la regla ESLint
 * `enforce-logging-service`.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `LoggingService`.
 */
export function providerLoggingServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new LoggingEmbeddedService() : new LoggingService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `LoggingService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerLoggingServiceFactory}. Siempre inyecta `LoggingService`
 * (no el token directamente) gracias al alias `useExisting`.
 */
export const LoggingServiceToken = new InjectionToken<LoggingService>('LoggingService')
